import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Tooltip } from "@material-ui/core";

import { locationData } from "../location/locationData";

const LocationField = ({data, setData, setLoader, setDialogIsOpen}) => {

    const locRef = useRef();
    const [isOpen, setOpen] = useState(false);
    const [isSearchDropDownOpen, setSearchDropDownOpen] = useState(false);
    const { locations } = useSelector((state) => state.keywords);

    useEffect(() => {
        document.addEventListener("click", handleClick);
        return () => document.removeEventListener("click", handleClick);
    }, []);

    useEffect(() => {
        document.addEventListener("keydown", handleEscapeBtn);
        return () => document.removeEventListener("keydown", handleEscapeBtn);
    }, []);

    const handleClick = (e) => {
        if (locRef.current.contains(e.target)) {
            // do nothing
        } else {
            closeDropDowns();
        }
    };

    const handleEscapeBtn = (e) => {
        if (e.key === "Escape") {
            closeDropDowns();
        }
    };

    function closeDropDowns() {
        setSearchDropDownOpen(false);
        setOpen(false);
        setLoader(false);
    }

    const onLocationChanged = (e) => {
        setSearchDropDownOpen(true);
        setOpen(false);

        setData((prevState) => ({
            ...prevState,
            loc: e.target.value
        }));
    };

    const onLocationFocus = () => {
        setSearchDropDownOpen(false);
        setOpen(true);
    };

    const handleLocationSuggestion = (loc) => {
        setOpen(false);
        if (loc === "current-loc") {
            setLoader(true);
            checkGeoLocationPermission();
        } else {
            setData((prevState) => ({
                ...prevState,
                loc: loc.loc,
                lat: loc.lat,
                lng: loc.lng,
                radius: loc.radius,
            }));
        }
    };

    const checkGeoLocationPermission = () => {
        let options = {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0,
        };

        navigator.permissions
            .query({
                name: "geolocation",
            })
            .then(function (result) {
                if (result.state == "granted") {
                    navigator.geolocation.getCurrentPosition(
                        onSuccess,
                        onError,
                        options
                    );
                } else if (result.state == "prompt") {
                    navigator.geolocation.getCurrentPosition(
                        onSuccess,
                        onError,
                        options
                    );
                } else if (result.state == "denied") {
                    setLoader(false);
                    setDialogIsOpen(true);
                }
            });
    };

    const onSuccess = async (location) => {
        setData((prevState) => ({
            ...prevState,
            loc: "Current Location",
            lat: location.coords.latitude,
            lng: location.coords.longitude,
            radius: "25",
        }));

        // let result = await GetAddress(location.coords);
        // Get Location
        // if (result) {
        //     let subLocation = "";
        //     subLocation = getLocality(result);
        //     setSearchValue(subLocation);
        //     setData((data) => ({ ...data, ["loc"]: subLocation }));
        // }
        setLoader(false);
    };

    const onError = (error) => {
        setLoader(false);
        alert("Error getting your current location.");
    };

    const handleLocationSelection = async (e, address) => {
        e.preventDefault();
        setSearchDropDownOpen(false);
        setData((prevState) => ({
            ...prevState,
            loc: address.name,
            lat: address.latitude,
            lng: address.longitude,
            radius: 25
        }));
    }

    const handleClear = () => {
        setData((prevState) => ({
            ...prevState,
            loc: "",
            lat: "",
            lng: "",
            radius: "",
        }));

    //    localStorage.removeItem("recent");
        setLoader(false);
    };

    return (
        <div
            className="main-search-input-item location autocomplete-container"
            ref={locRef}
        >
            <label>
                <i className="fal fa-map-marker-check"></i>
            </label>
            <input
                id="location"
                type="text"
                placeholder="Enter City or Town"
            //    value={searchValue}
                value={data.loc}
                autoComplete="off"
                onChange={onLocationChanged}
                onFocus={onLocationFocus}
                className="autocomplete-input"
            //    ref={placeInputRef}
            />
            <ul className={isOpen ? "d-block" : "d-none"}>
                <li className="current-loc" onClick={() => handleLocationSuggestion("current-loc")}>
                    Current Location
                </li>
                {locationData && locationData.length > 0 && (
                    <>
                        {locationData.map((loc, i) => 
                            <li 
                                key={i}
                                onClick={() => handleLocationSuggestion(loc)}            
                            >
                                {loc.loc}
                            </li>
                        )}
                    </>
                )}
            </ul>
            {locations.length > 0 && (
                <ul className={isSearchDropDownOpen ? "d-block" : "d-none"}>
                    {locations.filter(item => {
                    //    const searchTerm = searchValue && searchValue.toLowerCase();
                        const searchTerm = data.loc && data.loc.toLowerCase();
                        const loc = item.name.toLowerCase();
                        
                        return searchTerm && loc.startsWith(searchTerm);
                    })
                    .slice(0, 10)
                    .map((address) => (
                        <li
                            key={address.id}
                            onClick={(e) =>
                                handleLocationSelection(e, address)
                            }
                        >
                            {address.name}
                        </li>
                    ))}
                </ul>
            )} 
            {/* {predictions &&
                predictions !== null &&
                predictions.data.length > 0 && (
                    <ul className={isSearchDropDownOpen ? "d-block" : "d-none"}>
                        {predictions.data.map((prediction) => (
                            <li
                                key={prediction.place_id}
                                onClick={(e) =>
                                    handlePredictionSelection(e, prediction)
                                }
                            >
                                {prediction.display_name || "Not found"}
                            </li>
                        ))}
                    </ul>
                )} */}
            <Tooltip title="Clear" placement="top">
                <span onClick={() => handleClear()}>
                    <i className="far fa-times-circle"></i>
                </span>
            </Tooltip>
        </div>
    );
};

export default LocationField;